import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import HandleStatus from "./handleStatus";
import convertDate from "./convertDate";

const Assessment = (props) => {
    const navigate = useNavigate();
    const { courseCode } = useParams();

    const handleNameClick = (event) => {
        if (event.metaKey || event.ctrlKey) {
            // Open in a new tab
            window.open(`/${courseCode}/${props.assessmentCode}/${props.submission === "" ? "" : props.submission.email}`, '_blank');
        } else {
            // Navigate in the same tab
            navigate(`/${courseCode}/${props.assessmentCode}/${props.submission === "" ? "" : props.submission.email}`);
        }
    }

    return (
        <>
            <div className="exam-container">
                <div className="course-metadata-2"> 
                    <div className={ props.widthTwo ? "arrow-container-1 color fifty" : "arrow-container-1 color" }>
                        <div className="assessment-name-container">
                            { props.widthTwo ? HandleStatus(props.status) : ""}
                            <div className="assessname" onClick={handleNameClick}> { props.name } </div>
                        </div>
                    </div>
                    {
                        props.widthTwo

                        ?
                            <></>
                        :

                            <div className={ props.width ? "arrow-container-2-2 color" : "arrow-container-2 color" }>
                                { HandleStatus(props.status) } { props.status === "Submitted" ? (props.published ? (props.endedExam ? "Submitted" : "Unfinished") : "Unpublished") : props.status }
                            </div>

                    }                
                    <div className={ props.width ? props.widthTwo ? "arrow-container-4-2 color special fifty" : "arrow-container-4-2 color special" : "arrow-container-4 color special" }>
                        <div>
                            { convertDate(props.start, true, props.timeZone) }
                        </div> 
                        <div>
                            { convertDate(props.end, true, props.timeZone) }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Assessment;